import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { OptionType } from '../../../../../CommonComponents/OPL/Select/BaseSelect/types';

interface Props<T extends FieldValues> {
  control: Control<T>;
  formKey: Path<T>;
  options: OptionType<number>[] | null;
  isDisabled: boolean;
}

export function AssetBucketSelect<T extends FieldValues>({
  control,
  formKey,
  options,
  isDisabled,
}: Props<T>) {
  if (!options) {
    return null;
  }

  return (
    <Controller
      name={formKey}
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            label="Asset Bucketing"
            value={
              options.find(option => option.value === value) ||
              options.find(({ rightLabel }) => rightLabel === 'Default') ||
              null
            }
            options={options}
            placeholder={isDisabled ? 'Select Management Style' : 'Select Asset Bucketing'}
            onChange={option => onChange(option?.value)}
            isPortal
            disabled={isDisabled}
          />
        );
      }}
    />
  );
}
